module.exports = __webpack_public_path__ + "static/how-i-raised-myself-from-failure-to-success-in-selling-bc28e1fcccc38d9f4c2a59b55f2eaccc.jpg";